import {createFileRoute, useNavigate} from "@tanstack/react-router";
import {useBomb} from "../../../bomb/bomb.tsx";
import {useCallback, useMemo} from "react";
import {useDispatchTruckActors} from "../../../dispatch/dispatch.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {Comparator, invertComparator} from "../../../util/arutil.tsx";
import {SortOrder} from "../../../rpc/webrpc-client.gen.ts";
import {TileSpread} from "../../../components/Tile.tsx";
import {SuspenseDialog} from "../../../components/SuspenseDialog.tsx";
import {pendingUseResult, successUseResult} from "../../../util/hookutil.tsx";
import {dispatchTruckAscSorters, TruckActor} from "../../../truck/timeline.tsx";
import {
    DispatchOverviewSettings,
    validateDispatchOverviewSettings
} from "../../../dispatch/dispatchOverviewSettings.tsx";
import {IconToggleSwitch, ToggleBar} from "../../../components/ToggleBar.tsx";
import {Stack} from "@mui/joy";
import {tieredActiveIcons} from "../../../fa.tsx";
import {sortOrderIcons} from "../../../tq/tqutil.tsx";
import {DispatchFacetEntity, dispatchFacetIcons} from "../../../dispatch/dispatchFacet.tsx";
import {DispatchTruckTile} from "../../../dispatch/DispatchTruckTile.tsx";
import {TieredOrActive} from "../../../dispatch/tieredOrActive.tsx";

function DispatchTruckSpread() {
    const {order, sortOrder}: DispatchOverviewSettings = Route.useSearch();
    const cmp: Comparator<TruckActor> = useMemo(() => {
        let rv = dispatchTruckAscSorters[order];
        if (sortOrder === SortOrder.enum.DESC) {
            rv = invertComparator(rv);
        }
        return rv;
    }, [order, sortOrder]);
    const unsortedDxtsTqrv = useDispatchTruckActors();
    const dxtsTqrv = useMemo(() => {
        if (!unsortedDxtsTqrv.data) {
            return pendingUseResult;
        }
        const sorted = unsortedDxtsTqrv.data.toSorted(cmp);
        return successUseResult(sorted);
    }, [cmp, unsortedDxtsTqrv.data]);
    const dxts = dxtsTqrv.data;

    if (!dxts) {
        return <SuspenseDialog/>;
    }

    // useWhatChanged([dxts]);

    // if (!dxts) {
    //     return <SuspenseDialog message="fetching truck overview"/>
    // }
    //

    // const fakeTrucks = useMemo(() => {
    //     const rv = new Array(100).fill(true).map((_, ix) => {
    //         const tst:e TruckStub = {
    //             id: ix.toString(),
    //             displayName: makeOutletSlug(),
    //             code: Math.floor(((Math.random() * 10000))).toString(),
    //         };
    //         return tst;
    //     });
    //     return rv;
    // }, []);
    //

    return <TileSpread foods={dxts} Component={({food: dxt}) => {
        return <DispatchTruckTile dxt={dxt}/>;
    }} estimatedHeight={180}/>
}

function DispatchTruckPage() {
    const navigate = useNavigate();
    const search = Route.useSearch();
    const bomb = useBomb();
    const setFacet = useCallback((next: DispatchFacetEntity) => {
        navigate({to: `/dispatch/${next}`, search}).catch(bomb);
    }, [bomb, navigate, search]);
    const order = search.order;
    const setOrder = useCallback((next: TieredOrActive) => {
        navigate({to: Route.to, params: {facet: "truck"}, search: {...search, order: next}}).catch(bomb);
    }, [bomb, navigate, search]);
    const sortOrder = search.sortOrder;
    const setSortOrder = useCallback((next: SortOrder) => {
        navigate({to: Route.to, params: {facet: "truck"}, search: {...search, sortOrder: next}}).catch(bomb);
    }, [bomb, navigate, search]);

    return <PageShell>
        <PageHeader>
            <Stack direction="column">
                <TopBar/>
                <ToggleBar>
                    <IconToggleSwitch dispatchValue={setOrder} icons={tieredActiveIcons} value={order}/>
                    <IconToggleSwitch dispatchValue={setFacet} icons={dispatchFacetIcons} value="truck"/>
                    <IconToggleSwitch dispatchValue={setSortOrder} icons={sortOrderIcons} value={sortOrder}/>
                </ToggleBar>
            </Stack>
        </PageHeader>
        <PageBody>
            <DispatchTruckSpread/>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/dispatch/truck")({
    component: DispatchTruckPage,
    // params: {
    //     parse: (raw: Record<string, unknown>) => {
    //         const rv = DispatchSearchParams.parse(raw);
    //         return rv;
    //     },
    // },
    validateSearch: validateDispatchOverviewSettings,
});